import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("oed_token", data.token);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-oed-base flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="w-full max-w-md"
      >
        <a href="/" className="inline-block"><img src="/logo.png" alt="OED Glampire Network" className="h-14 w-14 object-contain" /></a>
        <p className="mt-8 text-xs uppercase tracking-[0.3em] text-oed-gold">Dealer Admin</p>
        <h1 className="mt-3 font-display font-bold text-4xl tracking-tight">Sign in</h1>

        <form onSubmit={submit} className="mt-10 space-y-8" data-testid="admin-login-form">
          <label className="block">
            <span className="text-[11px] uppercase tracking-[0.2em] text-white/40">Email</span>
            <input
              data-testid="admin-email-input"
              type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              className="mt-2 w-full bg-transparent border-b border-white/20 py-3 text-white placeholder-white/25 focus:border-oed-gold focus:outline-none transition-colors"
              placeholder="admin@oedglampire.com"
            />
          </label>
          <label className="block">
            <span className="text-[11px] uppercase tracking-[0.2em] text-white/40">Password</span>
            <input
              data-testid="admin-password-input"
              type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
              className="mt-2 w-full bg-transparent border-b border-white/20 py-3 text-white placeholder-white/25 focus:border-oed-gold focus:outline-none transition-colors"
              placeholder="••••••••"
            />
          </label>
          <button
            data-testid="admin-login-submit"
            type="submit" disabled={loading}
            className="w-full bg-white text-black py-4 text-sm font-medium hover:bg-oed-gold transition-colors disabled:opacity-50"
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <a href="/" className="mt-8 inline-block text-sm text-white/40 hover:text-white transition-colors">← Back to site</a>
      </motion.div>
    </div>
  );
}
